/**
 * Created by Mark on 18/04/2017.
 */

import React from 'react';
import Menu  from './navigation-menu.js';
import NavigationService from '../../services/navigation-service.js';
import NavigationStore from '../../store/navigation-store.js';
import AuthenticationService from '../../services/authenticate-services.js';
import AuthenticationStore from '../../store/authentication-store.js';
import { OverlayTrigger , Tooltip , Button , Modal } from 'react-bootstrap';
import { Link , hashHistory } from "react-router";
import Chat from '../../classes/chat_client.js';
import { FormattedMessage } from 'react-intl';
import InternationalizationStore from '../../store/internationalization-store.js';

export default class NavigationComponent extends React.Component {

    constructor(props){
        super();

        this.state = {
            nodes:[],
            menuToggled:props.toggle,
            showLogout:false,
        };

        this.handelToggle = props.handelToggle || function (){}
    }

    componentWillReceiveProps(props){
        this.setState({menuToggled:props.toggle})
    }

    componentDidMount(){
        NavigationService.fetchMenuItems();
        AuthenticationService.getUnixPermissions();
    }

    componentWillMount(){

        NavigationStore.on("CHANGE" , () => {
            this.setState({nodes: NavigationStore.menuitems,})
        });

        AuthenticationStore.on("GOT_PERMISSION" , () => {
            this.setState({got: true})
        });


    }

    handelChatToggel(){
        (new Chat()).toggleChatClient();
    }

    handelJumpto(){

        if(sessionStorage.getItem('product') == "huber" || sessionStorage.getItem("product") == "klett" || 
            sessionStorage.getItem('product') == "larousse" || sessionStorage.getItem('product') == "hodder" || 
            sessionStorage.getItem('product') == "cornelson")
        {
            return window.location.href = window.location.origin + "/resources/#/Curriculum";
        }

        window.location.href = window.location.origin + "/resources";
    }

    handelJumptoHome(){
        window.open('pdf/'+InternationalizationStore.getInstructionsPDF());
    }

    handelLogout(){
        sessionStorage.clear();
        window.location.href = window.location.origin + "/resources/#/LoginScreen";
    }

    toggleLogout(){
        this.setState({showLogout:!this.state.showLogout})
    }

    render(){

        let Chat = null;
        let Help = null;

        if(sessionStorage.getItem("product") == "languagenut")
        {
            Chat = <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-885' } defaultMessage={ 'Chat' }/></Tooltip>}>
                <li onClick={this.handelChatToggel}>
                    <i  className="palette-Branding  text zmdi zmdi-email"></i>
                </li>
            </OverlayTrigger>
        }

        if(!InternationalizationStore.removeInstructionsPDF())
        {
            Help = <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-793' } defaultMessage={ 'Chat' }/></Tooltip>}>
                <li onClick={this.handelJumptoHome}>
                    <i  className="palette-Branding  text zmdi zmdi-help"></i>
                </li>
            </OverlayTrigger>
        }

        return <aside id="s-main-menu" className={(this.state.menuToggled ? 'toggled ': '' ) + "sidebar"}>
            <Modal show={this.state.showLogout} onHide={this.toggleLogout.bind(this)}>
                <Modal.Header>
                    <Modal.Title><FormattedMessage id={ 'ui-40' } defaultMessage={ 'Edit' }/></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <FormattedMessage id={ 'ui-223' } defaultMessage={ 'No MSG' }/>

                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.toggleLogout.bind(this)}><FormattedMessage id={ 'ui-41' } defaultMessage={ 'Cancle' }/></Button>
                    <Button onClick={this.handelLogout.bind(this)} bsStyle="primary"><FormattedMessage id={ 'ui-40' } defaultMessage={ 'Save' }/></Button>
                </Modal.Footer>

            </Modal>

                    <div onClick={this.handelToggle} className="smm-header">
                        <div className="pull-right smm-logo hidden-sm hidden-md">
                            <Link to='/dashboard' className="pull-right">
                                <img src="img/logos/languagenut/no-text-logo.png"></img>
                            </Link>
                        </div>
                        <i className="zmdi zmdi-long-arrow-left" data-ma-action="sidebar-close"></i>
                    </div>

                    <ul className="smm-alerts">
                        {Help}
                        {Chat}
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-460' } defaultMessage={ 'Jump to resources' }/></Tooltip>}>
                        <li  onClick={this.handelJumpto}>
                            <i className="palette-Branding  text zmdi zmdi-library"></i>
                        </li>
                        </OverlayTrigger>
                        <OverlayTrigger  id="logout" placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-40' } defaultMessage={ 'Logout' }/></Tooltip>}>
                        <li id="logout" onClick={this.toggleLogout.bind(this)}>
                            <i className="palette-Branding  text zmdi zmdi-power"></i>
                        </li>
                        </OverlayTrigger>
                    </ul>
                    <ul className="main-menu">
                        <Menu  nodes={this.state.nodes }/>
                    </ul>
               </aside>
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/navigation.js